import { useStaticQuery, graphql } from "gatsby"

export const useImage = (imagePath) => {
        const data = useStaticQuery(graphql`
        {
            allFile(filter: {sourceInstanceName: {eq: "images"}}) {
              edges {
                node {
                  publicURL
                  relativePath
                }
              }
            }
        }
        `)    
        const image = data.allFile.edges.find(edge => edge.node.relativePath === imagePath)
        if (!image) {
          console.log("image null", imagePath)
        }
        return (image) ? image.node : null
    
    
}